module.exports = __webpack_public_path__ + "img/A05.930fe3fd.jpg";